module.exports = __webpack_public_path__ + "img/009-uganda.a7021a7d.svg";